import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  wrapper: {
    width: '100%',
    padding: theme.spacings.md,
  },
  headerRow: {
    width: '100%',
    marginBottom: theme.spacings.md,
  },
  headerText: {
    fontSize: theme.fontSizes['2xl'],
    textAlign: 'center',
    fontWeight: '600',
    color: theme.colors.black,
  },
  buttonsRow: {
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
  },
  buttonLeft: {
    padding: theme.spacings.sm,
    borderRadius: theme.borderRadii.md,
    backgroundColor: theme.colors.grey,
    marginRight: theme.spacings.sm,
  },
  button: {
    padding: theme.spacings.sm,
    borderRadius: theme.borderRadii.md,
    backgroundColor: theme.colors.grey,
  },
  buttonContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconMargin: {
    marginRight: theme.spacings.xs,
  },
  buttonText: {
    fontSize: theme.fontSizes['2xl'],
  },
});
